import { Container, Skeleton } from '@mui/material';

export const Loading = () => {
  return (
    <Container sx={{ p: 2 }}>
      <Skeleton variant="rounded" sx={{ height: 50 }} />
      <Skeleton variant="rounded" sx={{ mt: 1, height: 50 }} />
      <Skeleton variant="rounded" sx={{ mt: 1, height: 50 }} />
    </Container>
  );
};
